/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiTicketsAdminOrdersGetPageParameter
 */
export interface ApiTicketsAdminOrdersGetPageParameter {
}

/**
 * Check if a given object implements the ApiTicketsAdminOrdersGetPageParameter interface.
 */
export function instanceOfApiTicketsAdminOrdersGetPageParameter(value: object): value is ApiTicketsAdminOrdersGetPageParameter {
    return true;
}

export function ApiTicketsAdminOrdersGetPageParameterFromJSON(json: any): ApiTicketsAdminOrdersGetPageParameter {
    return ApiTicketsAdminOrdersGetPageParameterFromJSONTyped(json, false);
}

export function ApiTicketsAdminOrdersGetPageParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTicketsAdminOrdersGetPageParameter {
    return json;
}

export function ApiTicketsAdminOrdersGetPageParameterToJSON(json: any): ApiTicketsAdminOrdersGetPageParameter {
    return ApiTicketsAdminOrdersGetPageParameterToJSONTyped(json, false);
}

export function ApiTicketsAdminOrdersGetPageParameterToJSONTyped(value?: ApiTicketsAdminOrdersGetPageParameter | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

